export default __webpack_public_path__ + "static/tour_02_relatable_expert-0821d1b0d67981fede68b901f7f4b361.jpg";